import React from 'react';

export default function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="text-center max-w-md px-6">
        <div className="font-display text-2xl tracking-tight leading-none text-secondary-900 mb-6">
          ONLY<span className="text-gold-700">KICKERS</span>
        </div>
        <h1 className="font-display uppercase text-3xl leading-none text-ink-900 mb-3">Something Went Wrong</h1>
        <p className="text-secondary-600 mb-6">
          An unexpected error occurred. The issue has been reported automatically.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="btn-primary"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}
